// @flow
import axios from "axios";
import queryString from "query-string";
import { Base64 } from "js-base64";
import esb from "elastic-builder";
import { endpoints } from "../../c21-api";
import { buildSingleValueFilterQuery, buildRangeFilterQuery } from "../shared";

class MultiAgencySearch {
    endpoint = endpoints.properties;
    agencies: Array<*>;
    pageSize: number;
    current: { page: number };

    constructor(agencies: Array<*>, pageSize: number) {
        this.agencies = agencies;
        this.pageSize = pageSize;
        this.current = { page: 1 };
    }

    buildElasticQuery = (): * => {
        const agencyQueries = this.agencies
            .map((agency) => {
                const agencyId = agency.api_id || agency.id;
                return buildSingleValueFilterQuery(
                    "agencyId.keyword",
                    agencyId,
                );
            })
            .filter((query) => !!query);

        const matchQueries = [
            esb.boolQuery().should(agencyQueries),
            buildRangeFilterQuery("creationDate", {
                upper: window.__BUILD_TIMESTAMP__,
            }),
        ].filter((query) => !!query);

        const query = esb
            .boolQuery()
            .filter([esb.boolQuery().must(matchQueries)]);

        return query;
    };

    async search() {
        try {
            const request = queryString.stringifyUrl({
                url: this.endpoint,
                query: {
                    filter: Base64.encode(
                        JSON.stringify(this.buildElasticQuery()),
                    ),
                    pageSize: this.pageSize,
                    sort: "-creationDate",
                    page: this.current.page - 1,
                },
            });

            return axios.get(request);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Error in multi-agency search:", error);
            throw error;
        }
    }

    setPage(page: number) {
        this.current.page = page;
    }
}

const MultiAgencySearchFactory = {
    fromAgenciesAndPageSize: (
        mainAgency: *,
        relatedAgencies: Array<*> = [],
        pageSize: number,
    ) => {
        return new MultiAgencySearch(
            [mainAgency, ...relatedAgencies],
            pageSize,
        );
    },
};

export default MultiAgencySearchFactory;
